import { render, staticRenderFns } from "./BaseInputText.vue?vue&type=template&id=7a31da79&"
import script from "./BaseInputText.vue?vue&type=script&lang=ts&"
export * from "./BaseInputText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports